var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "main hidden-xs-only" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            attrs: {
              data: _vm.processos,
              "element-loading-text": "Carregando..."
            }
          },
          [
            _c("template", { slot: "empty" }, [_vm._v("Não há registros.")]),
            _c("el-table-column", {
              attrs: { prop: "numeroProcesso", label: "Processo", width: "130" }
            }),
            _c("el-table-column", {
              attrs: {
                prop: "nomeRazaoSocialInteressado",
                label: _vm.isIcmBio
                  ? "Nome/razão social do interessado ou nome da UC"
                  : "CPF/CNPJ do interessado:",
                width: "auto"
              }
            }),
            _c("el-table-column", {
              attrs: {
                prop: "tipo.nome",
                label: "Tipo de processo",
                width: "auto"
              }
            }),
            _c("el-table-column", {
              attrs: {
                label: "Status",
                prop: "status",
                width: _vm.isMA ? "auto" : 150,
                formatter: _vm.getStatusFormatado
              }
            })
          ],
          2
        ),
        _c("br")
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hidden-sm-and-up" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            attrs: {
              data: _vm.processos,
              "element-loading-text": "Carregando..."
            }
          },
          [_c("template", { slot: "empty" }, [_vm._v("Não há registros.")])],
          2
        ),
        _vm._l(_vm.processos, function(processo) {
          return _c("div", { staticClass: "row" }, [
            _c("p", [
              _vm._v("Processo:"),
              _c("span", [_vm._v(_vm._s(processo.numeroProcesso))])
            ]),
            _c("p", [
              _vm._v("Nome/Razão social do interessado:"),
              _c("span", [_vm._v(_vm._s(processo.nomeRazaoSocialInteressado))])
            ]),
            _c("p", [
              _vm._v("Tipo de processo:"),
              _c("span", [_vm._v(_vm._s(processo.tipo.nome))])
            ]),
            _c("p", [
              _vm._v("Status:"),
              _c("span", [_vm._v(_vm._s(processo.status))])
            ])
          ])
        }),
        _c("br")
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "pagination" },
      [
        _c("el-pagination", {
          attrs: {
            "page-size": _vm.pageSize,
            "current-page": _vm.page,
            layout: "prev, pager, next",
            total: _vm.totalItems
          },
          on: {
            "current-change": function($event) {
              return _vm.changePage()
            },
            "update:currentPage": function($event) {
              _vm.page = $event
            },
            "update:current-page": function($event) {
              _vm.page = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dc9cf2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dc9cf2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/ListagemProcessos.vue
// module id = null
// module chunks = 